import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import React, { Component } from 'react';

/* Object Json */
import { safeDeepDel, safeDeepGet, safeDeepGetWithType, safeDeepSet } from 'iotera-base/json';
import { isFunction, isObject } from 'iotera-base/object';

export class SelectionDevice extends Component {
  constructor(props) {
    super(props);
    const _parent = safeDeepGet(props, ['_parent']);
    let devices = {};
    devices = {
      devices_label: safeDeepGetWithType(_parent, ['state', 'devices_label'], {}),
      devices: safeDeepGetWithType(_parent, ['state', 'devices'], {})
    }
    this.state = {
      devices
    }
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const name = safeDeepGetWithType(event, ['target', 'name'], '');
    const value = safeDeepGet(event, ['target', 'value'], '');
    const _parent = safeDeepGet(_props, ['_parent']);
    let finalData = safeDeepGetWithType(_state, ['finalData'], {});
    let checkSubmitable = safeDeepGet(_props, ['checkSubmitable'])
    let _handleChange = safeDeepGet(_props, ['handleChange'])
    if (isFunction(_handleChange)) {
      _handleChange(event)
    }
    const isFunc = isFunction(checkSubmitable);
    if (name === 'varFDevId') {
      safeDeepSet(finalData, ['device_id'], value)
      safeDeepDel(finalData, ['sensor'])
      safeDeepDel(finalData, ['config'])
      safeDeepDel(finalData, ['param'])
      _this.setState({
        [name]: value,
        finalData,
        varFSensor: null,
        varFConfig: null,
        varFParam: null,
      })
    } else if (name === 'varFSensor') {
      safeDeepSet(finalData, ['sensor'], value)
      safeDeepDel(finalData, ['config'])
      safeDeepDel(finalData, ['param'])
      _this.setState({
        [name]: value,
        finalData,
        varFConfig: null,
        varFParam: null
      })
      if (isFunc) {
        checkSubmitable('varValue', {});
      }
    } else if (name === 'varFConfig') {
      safeDeepSet(finalData, ['config'], value)
      safeDeepDel(finalData, ['param'])
      _this.setState({
        [name]: value,
        finalData,
        varFParam: null
      })
      if (isFunc) {
        checkSubmitable('varValue', {});
      }
    } else if (name === 'varFParam') {
      safeDeepSet(finalData, ['param'], value)
      _this.setState({
        [name]: value,
        finalData
      })
      if (isFunc) {
        checkSubmitable('varValue', finalData);
      }
    } else if (name === 'varFLabel') {
      safeDeepSet(finalData, ['label'], value)
      if (value === '') {
      safeDeepDel(finalData, ['label'])
      }
      _this.setState({
        [name]: value,
        finalData
      })
      if (isFunc) {
        let param = safeDeepGetWithType(finalData, ['param'], '')
        if (param === '') {
          checkSubmitable('varValue', {});
        } else {
          checkSubmitable('varValue', finalData);
        }
      }
    }
    _parent.setState({ finalData })
  }
  render() {
    const _this = this
    const _state = _this.state
    let allDevices = safeDeepGetWithType(_state, ['devices'], {});
    let varFDevId = safeDeepGetWithType(_state, ['varFDevId'], '');
    let varFSensor = safeDeepGetWithType(_state, ['varFSensor'], '');
    let varFConfig = safeDeepGetWithType(_state, ['varFConfig'], '');
    let varFParam = safeDeepGetWithType(_state, ['varFParam'], '');
    let varFLabel = safeDeepGetWithType(_state, ['varFLabel'], '');
    let devices = safeDeepGetWithType(allDevices, ['devices'], {});
    let devices_label = safeDeepGetWithType(allDevices, ['devices_label'], {});
    let menuDevices = []
    for (let device in devices) {
      let device_label = safeDeepGetWithType(devices_label, [device], '')
      menuDevices.push(
        <MenuItem value={device} >{device_label}</MenuItem>
      )
    }
    let menuSensors = []
    if (varFDevId !== '') {
      const currDevice = devices[varFDevId];
      if (isObject(currDevice)) {
        for (let sensor in currDevice) {
          menuSensors.push(
            <MenuItem value={sensor} >{sensor}</MenuItem>
          )
        }
      }
    }
    let menuConfigs = []
    if (varFDevId !== '' && varFSensor !== '') {
      const currSensor = devices[varFDevId][varFSensor];
      if (isObject(currSensor))
        for (let config in currSensor) {
          menuConfigs.push(
            <MenuItem value={config} >{config}</MenuItem>
          )
        }
    }
    let menuParams = []
    if (varFDevId !== '' && varFSensor !== '' && varFConfig !== '') {
      const currConfig = devices[varFDevId][varFSensor][varFConfig];
      if (isObject(currConfig))
        for (let param in currConfig) {
          menuParams.push(
            <MenuItem value={param} >{param}</MenuItem>
          )
        }
    }
    return (
      <div>
        <FormControl style={{ minWidth: '100%' }}  >
          <TextField
            type="string"
            margin='dense'
            value={varFLabel}
            inputProps={{
              name: 'varFLabel'
            }}
            label={'Label'}
            onChange={_this.handleChange}
          />
        </FormControl>
        <FormControl required style={{ minWidth: '100%', marginTop: 5 }} >
          <InputLabel>Perangkat</InputLabel>
          <Select
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            value={varFDevId}
            onChange={_this.handleChange}
            inputProps={{
              name: 'varFDevId'
            }}
          >
            {menuDevices}
          </Select>
        </FormControl>
        {
          menuSensors.length > 0 &&
          <FormControl required style={{ minWidth: '100%', marginTop: 5 }} >
            <InputLabel>Sensor</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFSensor}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFSensor'
              }}
            >
              {menuSensors}
            </Select>
          </FormControl>
        }
        {
          menuConfigs.length > 0 &&
          <FormControl required style={{ minWidth: '100%', marginTop: 5 }} >
            <InputLabel>Config</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFConfig}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFConfig'
              }}
            >
              {menuConfigs}
            </Select>
          </FormControl>
        }
        {
          menuParams.length > 0 &&

          <FormControl required style={{ minWidth: '100%', marginTop: 5 }} >
            <InputLabel>Param</InputLabel>
            <Select
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              value={varFParam}
              onChange={_this.handleChange}
              inputProps={{
                name: 'varFParam'
              }}
            >
              {menuParams}
            </Select>
          </FormControl>
        }
      </div >
    );
  }
}